import { GridFilterModel, GridRowId } from "@mui/x-data-grid-premium";
import { createSlice } from "@reduxjs/toolkit";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
interface ITaniTanim {
    expandedRows: Record<GridRowId, boolean>;
    filterModel: GridFilterModel;
};

export const TaniTanimSlice = createSlice<ITaniTanim, MapReducerPayloads<ITaniTanim, {
    setExpandedRows: Record<GridRowId, boolean>;
    setFilterModel: GridFilterModel;
}>>({
    name: "taniTanim",
    initialState: {
        expandedRows: {},
        filterModel: { items: [], quickFilterValues: [] }
    },
    reducers: {
        /**
         * Datagridde ekleme, düzenleme, silme veya arama yapıldığında expand edilen satırların tutulduğu state
         * @param state 
         * @param action 
        */
        setExpandedRows: (state, action) => {
            state.expandedRows = action.payload;
        },
        /**
         * Datagrid filterModel event değerlerinin tutulması için kullanılan state
         * @param state 
         * @param action 
        */
        setFilterModel: (state, action) => {
            state.filterModel = action.payload;
        }
    }
});